import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'

dayjs.extend(utc);
dayjs.extend(timezone);

function Convert_to_LocalTime(date, returnFormat = 'YYYY-MM-DD HH:mm:ss', getFormat = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs().utcOffset(date, getFormat, dayjs.tz.guess()).format(returnFormat);
}

const EMAIL_VALIDATION = () => {
    return ({ required: "Please enter email address", pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Please enter valid email address", }, })
};

const TOAST_SUCCESS = (message) => {
    return toast.success(message);
};

const TOAST_ERROR = (message) => {
    return toast.error(message);
};

const COMMON_STYLE_FOR_POPUP = () => {
    return ({
      content: {
        // backgroundColor: 'rgb(0 0 0 / 56%)',
        background: 'none',
        border: '0px',
      },
    })
};

const SWIT_SUCCESS = (message) => {
    return Swal.fire({
      position: 'top-center',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 1800
    })
  };

const discountTypeOption = [
  { value: 'FLAT_AMOUNT', label: 'FLAT_AMOUNT' },
  { value: 'PERCENTAGE', label: 'PERCENTAGE' },
  { value: 'FREE_MEAL', label: 'FREE_MEAL' },
]
  
export const otpTime = 300;

const hostname = window.location.hostname;
export const isLiveCredential = hostname === 'booking.foodforgood.ca';
export const payScript = isLiveCredential? process.env.REACT_APP_PAY_SCRIPT_LIVE : process.env.REACT_APP_PAY_SCRIPT
export { Convert_to_LocalTime, EMAIL_VALIDATION, TOAST_SUCCESS, TOAST_ERROR, COMMON_STYLE_FOR_POPUP, SWIT_SUCCESS, discountTypeOption};
